import { render, staticRenderFns } from "./media-buttons.vue?vue&type=template&id=0bf3a7a0&scoped=true&lang=pug&"
import script from "./media-buttons.vue?vue&type=script&lang=js&"
export * from "./media-buttons.vue?vue&type=script&lang=js&"
import style0 from "./media-buttons.vue?vue&type=style&index=0&id=0bf3a7a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf3a7a0",
  null
  
)

export default component.exports